import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { EMPTY, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AppStateService } from '@fb-tool-front/core/services/app-state.service';
import { AdAccountsService } from '@fb-tool-front/core/services/ad-accounts.service';
import { ErrorService } from '@fb-tool-front/core/services/error.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@fb-tool-front/core/services/auth.service';
import { UNAUTH_TYPE } from '../constants/shared.constant';
import { User } from '@sentry/types';
import { AdAccount } from '@fb-tool-front/statistics/adaccounts/adaccounts.models';

@Injectable({
  providedIn: 'root'
})
export class AdAccountsResolver implements Resolve<Observable<any>> {
  constructor(
    private adAccountsService: AdAccountsService,
    private authService: AuthService,
    private appStateService: AppStateService,
    private errorService: ErrorService,
    private translateService: TranslateService
  ) {}

  resolve() {
    return this.adAccountsService.get().pipe(
      map((adAccounts: AdAccount[]) => {
        if (Array.isArray(adAccounts) && adAccounts.length) {
          return adAccounts;
        }

        return of([]);
      }),
      catchError(err => {
        this.errorService.captureError(err);
        if (
          !(this.authService.user$$.getValue() as User)?.impersonated &&
          err.error?.error?.type === UNAUTH_TYPE
        ) {
          this.appStateService.navigateToStart({
            severity: 'token',
            message: this.translateService.instant('Please login with Facebook to proceed'),
            authUrl: err?.error?.error?.authorization_url
          });
        } else {
          this.appStateService.navigateToError({
            severity: 'error',
            message: err.message ? err.message : err
          });
        }

        return EMPTY;
      })
    );
  }
}
